<template>
  <div id="app">

    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 md12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>Uçuş Raporu</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field flat="" solo-inverted="" hide-details v-model="searchsatilanbilet" label=" Ara"
                append-icon="search"></v-text-field>
              <v-menu bottom="" left>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>




                  <v-list-tile @click="getListExcel()">
                    <v-list-tile-title>Excel İndir</v-list-tile-title>
                  </v-list-tile>

                </v-list>
              </v-menu>
            </v-toolbar>
          </v-flex>


          <v-container fluid>

            <v-form ref="formgunluksatis" v-model="valid" lazy-validation>
              <v-layout row wrap>

                <v-flex pb-3 xs12 sm12 md12>
                  <v-card flat>
                    <v-layout class=" pa-1 project overdue" row wrap>

                      <v-flex xs12 sm4 pt-2 md2>

           <tarihcomp :etiket="'Başlangıç Tarihi'" :detaygizle="false"
                    :rules="[v => !!v || 'Lütfen tarih seçiniz']" v-bind:defaultvalue="'ok'" v-bind:value="Rapor.BaslangicTarihi"
                    v-model="Rapor.BaslangicTarihi"></tarihcomp>



                      </v-flex>

                      <v-flex xs12 pt-2 sm4 md2>
                        <tarihcomp :etiket="'Bitiş Tarihi'" :detaygizle="false"
                          :rules="[v => !!v || 'Lütfen tarih seçiniz']" v-bind:defaultvalue="'ok'"
                          v-bind:value="Rapor.BitisTarih" v-model="Rapor.BitisTarihi"></tarihcomp>
                      </v-flex>

                      <v-flex pt-2>
                        <v-layout>
                          <div v-if="load1">
                            <v-btn color="info" @click="getList()" fab small="" dark>
                              <v-icon>search</v-icon>
                            </v-btn>
                          </div>
                          <div v-if="progress">
                            <v-layout pt-3 align-center="">
                              <v-progress-circular indeterminate :width="4" color="blue"></v-progress-circular>
                            </v-layout>
                          </div>
                          <v-badge color="white" :overlap="true">
                            <template v-slot:badge>
                              <v-icon v-if="filtrevarmi" large color="green">
                                check_circle_outline </v-icon>
                            </template>

                            <v-btn small="" @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab"
                              @click="filtrele()" color="info" fab dark>
                              <v-icon>filter_list</v-icon>
                            </v-btn>
                            <v-tooltip bottom="" :activator="el" v-model="tooltip">
                              <span>Arama Filtresi Ekle</span>
                            </v-tooltip>



                          </v-badge>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm12 md12>
                  <v-layout row wrap class="project overdue">


                    <v-layout row wrap>

                      <v-flex xs12 sm12 md12>
                        <v-card flat class="white--text">
                          <v-card-actions>
                            <v-flex xs12 sm12 md12>
                              <v-data-table :headers="headers" :rows-per-page-items=[20,100] :items="itemsichat"
                                :search="searchsatilanbilet">
                                <template slot="items" slot-scope="props">
                                  <td class="text-xs-left">{{ props.item.BiletNo }}</td>
                                  <td class="text-xs-left">{{ props.item.YolcuAdi}}</td>
                                  <td class="text-xs-center">{{ props.item.FiyatTur}}</td>
                                  <td class="text-xs-center">{{ props.item.UcusTipi}}</td>
                                  <td class="text-xs-center">{{ props.item.YolcuAdet}}</td>
                                  <td class="text-xs-center">{{ props.item.UcusTarihi | dateformat}}</td>
                                  <td class="text-xs-left">{{ props.item.UcusHY}}</td>
                                  <td class="text-xs-center">{{ props.item.UcusNo}}</td>
                                  <td class="text-xs-left">{{ props.item.Parkur}}</td>
                                  <td class="text-xs-center">{{ props.item.UcusSaat}}</td>
                                  <td class="text-xs-right">{{ props.item.VarisTarihi | dateformat}}</td>
                                  <td class="text-xs-center">{{ props.item.VarisSaat}}</td>
                                  <td class="text-xs-center">{{ props.item.FareBases}}</td>
                                  <td class="text-xs-center">{{ props.item | birlestir }}</td>
                                  <td class="text-xs-center">{{ props.item.Aktarma}}</td>
                                </template>
                                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                  Aradığınız "{{ searchsatilanbilet }}" kelimesi ile ilgili herhangi bir kayıt
                                  bulunamadı..
                                </v-alert>
                              </v-data-table>
                            </v-flex>

                          </v-card-actions>
                        </v-card>

                      </v-flex>
                    </v-layout>

                  </v-layout>
                </v-flex>

              </v-layout>
            </v-form>
          </v-container>

          <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
            :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
            {{ text1 }}
            <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
          </v-snackbar>



          <v-dialog v-model="dialogfiltre" scrollable="" persistent="" max-width="400px">
            <v-card color="grey lighten-5">
              <v-card-title>Filtre Seçimi</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row="" wrap="">


                  <v-flex xs12 sm12 md12 pa-1>
                    <v-card flat class="white--text">
                      <v-card color="grey lighten-5" flat="">
                        <v-card-actions>
                          <v-layout row="" wrap="">

                            <v-flex xs12 sm12 md12>
                              <havayollaricomp :etiket="'Hava Yolu Kodu'" v-model="havayolubil"></havayollaricomp>
                            </v-flex>
                            {{havayolubil}}
                            <v-flex xs12 sm12 md12>
                              <v-text-field hide-details="" mask="############" v-model="Rapor.BiletNo"
                                label="Bilet No">
                              </v-text-field>
                            </v-flex>


                            <v-flex xs12 md12 sm12>
                              <v-autocomplete hide-details="" clearable :items="itemsparkur" label="Parkur Seçimi"
                                multiple item-text="Title" v-model="Rapor.Parkurlar" item-value="ParkurKod">
                                <template slot="selection" slot-scope="{ item, index }">
                                  <div v-if="index === 0">
                                    <span>{{ item.Aciklama }}</span>
                                  </div>
                                  <span v-if="index === 1" class="grey--text caption">(+{{
                                                                Rapor.Parkurlar.length -
                                                                1
                                                                }} diğer)</span>
                                </template>
                              </v-autocomplete>
                            </v-flex>




                          </v-layout>
                        </v-card-actions>
                      </v-card>
                    </v-card>
                  </v-flex>



                </v-layout>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="filtreiptal()">İptal</v-btn>
                <v-btn color="blue darken-1" flat @click.native="filtrekayit()">Filtreleri Uygula</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>


<script>
  import auth from '../../../api/auth'
  import tarihcomp from '../customcomp/tarihim'
  import helpers from "@/components/app/customcomp/helpers.js"
  import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue"
  import masrafmerkezicomp from "@/components/app/bilet/partpage/masrafmerkezicomp.vue"
  import havayollaricomp from "@/components/app/bilet/partpage/havayollaricomp.vue"


  export default {
    data() {
      return {
        itemsparkur: [],
        filtrevarmi: false,
        sonuc: 0,
        itemscari: [],
        dipToplam: {
          SonucPosTutar: 0,
          ToplamBiletPosTutar: 0,
          ToplamBiletTutar: 0,
          ToplamCariAlacak: 0,
          ToplamCariBorc: 0,
          ToplamCariPosTutar: 0
        },
        bankapositems: [],
        havayolubil: {
          havayolukodu: null,
          formno: null
        },

        referansitems: [],
        evraktipi: [],
        search: '',
        searchsatilanbilet: null,
        searchiadebilet: null,
        searchvoid: null,


        headers: [{
            text: 'Bilet No',
            value: 'BiletNo',
            sortable: false
          },
          {
            text: 'Yolcu Adı',
            value: 'YolcuAdi',
            sortable: false

          },
          {
            text: 'FT',
            value: 'FiyatTur',
            sortable: false

          },
          {
            text: 'HT',
            value: 'UcusTipi',
            sortable: false

          },
          {
            text: 'Pax',
            value: 'YolcuAdet',
            sortable: false

          },
          {
            text: 'Uçuş Tarihi',
            value: 'UcusTarihi',
            sortable: false
          },
          {
            text: 'HY',
            value: 'UcusHY',
            sortable: false
          },
          {
            text: 'Uçuş No',
            value: 'UcusNo',
            sortable: false
          },
          {
            text: 'Parkur',
            value: 'Parkur',
            sortable: false
          },
          {
            text: 'Uçuş Saat',
            value: 'UcusSaat',
            sortable: false
          },
          {
            text: 'Varış Tarihi',
            value: 'VarisTarihi',
            sortable: false
          },
          {
            text: 'Varış Saat',
            value: 'VarisSaat',
            sortable: false
          },
          {
            text: 'Fare Bases',
            value: 'FareBases',
            sortable: false
          },
          {
            text: 'Acenta/Müşteri',
            value: 'AcentaKod',
            sortable: false
          },
          {
            text: 'Aktarma',
            value: 'Aktarma',
            sortable: false
          }
        ],


        Rapor: {
          BiletNo: null,
          CariKodu: null,
          HavayoluKodu: null,
          SirketKodu: null,
          BaslangicTarihi: null,
          BitisTarihi: null,
          FormNo: null,
          Parkurlar: [],
        },

        valid: true,
        tumsirketler: '',

        loading: false,
        items: [],
        load: false,
        load1: true,
        search3: '',

        renk1: 'info',
        dialogfiltre: false,
        hesapkodu: [],
        kredikarti: [],
        statecari: [],
        searchcari: '',
        progress: false,
        tooltip: false,
        el: null,
        yok: false,
        itemsichat: [],
        itemsdishat: [],
        masrafmerkezikodu: 'Masraf',
        butondurum: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        dictionary: {
          custom: {

            tarihsec: {
              required: () => 'Lütfen bir tarih seçiniz'
            },
            tarihsec1: {
              required: () => 'Lütfen bir tarih seçiniz'
            },
          }
        },
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },
    beforeMount: beforeMount,
    mounted() {
      this.$validator.localize('en', this.dictionary)
      this.el = this.$refs.fab.$el
    },
    filters: {

      birlestir: function (s) {
        var a
        var c
        if (s.AcentaKod != null && s.AcentaKod != '') {
          a = s.AcentaKod
        } else {
          a = '-'
        }
        if (s.CariKod != null && s.CariKod != '') {
          c = s.CariKod
        } else {
          c = '-'
        }
        return a + '/' + c
      },

      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },

      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }

    },

    components: {
      'tarihcomp': tarihcomp,
      referansmerkezicomp,
      masrafmerkezicomp,
      havayollaricomp,
    },
    watch: {
      searchcari(val) {
        val && this.carigetir(val)
      }

    },
    methods: {
      getList: getList,
      getListExcel: getListExcel,
      filtrele: filtrele,
      filtrekayit: filtrekayit,
      filtreiptal: filtreiptal,
      carigetir: carigetir
    }
  }


  function filtrele() {
    this.dialogfiltre = true

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {
      CompanyCode: credentials.SirketKodu
    }

    this.$http.post(auth.API_URL + 'api/TicketDefinitons/AirlineList', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.itemsairlinelist = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.progress = false

        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.progress = false

        this.snackbar = true
      }
    })

    this.$http.post(auth.API_URL + 'api/TicketDefinitons/ParkurList', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.itemsparkur = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.progress = false

        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.progress = false
        this.snackbar = true
      }
    })


  }


  function filtrekayit() {
    this.filtrevarmi = true
    this.dialogfiltre = false
    this.getList()
  }

  function filtreiptal() {
    this.filtrevarmi = false
    this.dialogfiltre = false
    this.Rapor.HavayoluKodu = null
    this.havayolubil.havayolukodu = null
    this.havayolubil.formno = null
    this.Rapor.Parkurlar = []
    this.Rapor.BiletNo = null
    this.getList();
  }


  function carigetir(v) {
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    if (v.length >= 0) {
      this.loading = true
      var params = {
        q: v,
        c: credentials.SirketKodu
      }
      setTimeout(() => {
        this.$http.post(auth.API_URL + 'api/options/CurrentSearch', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.statecari = response.body
          this.Error = false
        }, (response) => {
          if (response.status === 0) {
            this.text = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text = 'Service Unavailable'
            this.snackbar = true
          }
        })
        this.loading = false
      }, 500)
    }
  }


  function getList() {

    if (this.$refs.formgunluksatis.validate()) {


      var bastarih = new Date(this.Rapor.BaslangicTarihi)
      var bittarih = new Date(this.Rapor.BitisTarihi)

      if (bastarih <= bittarih) {

        this.progress = true
        this.load1 = false

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        this.Rapor.CariKodu = credentials.CariBilgi.Kod

        this.Rapor.SirketKodu = parseInt(credentials.CariBilgi.SirketKodu)

        if (this.havayolubil.havayolukodu != null) {
          this.Rapor.HavayoluKodu = this.havayolubil.havayolukodu
          this.Rapor.FormNo = this.havayolubil.formno
        }

        var params = this.Rapor

        this.$http.post(auth.API_URL + 'api/TicketReport/FlightReport', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {

          this.itemsichat = response.body
          this.progress = false
          this.load1 = true

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          }
        })
      } else {
        this.text1 = 'Başlangıç tarihi bitiş tarihinden büyük olamaz...'
        this.snackbar = true
      }
    }
  }




  function getListExcel() {

    if (this.$refs.formgunluksatis.validate()) {


      var bastarih = new Date(this.Rapor.BaslangicTarihi)
      var bittarih = new Date(this.Rapor.BitisTarihi)

      if (bastarih <= bittarih) {

       this.progress = true
        this.load1 = false

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        this.Rapor.CariKodu = credentials.CariBilgi.Kod

        this.Rapor.SirketKodu = parseInt(credentials.CariBilgi.SirketKodu)

        if (this.havayolubil.havayolukodu != null) {
          this.Rapor.HavayoluKodu = this.havayolubil.havayolukodu
          this.Rapor.FormNo = this.havayolubil.formno
        }

        var params = this.Rapor

        this.$http.post(auth.API_URL + 'api/TicketReport/FlightReportExcel', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          },
          responseType: "arraybuffer"
        }).then((response) => {

          var blob = new Blob([response.data], {
            type: 'application/xlsx'
          });
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = "UcusRaporu.xlsx";
          link.click();

          this.itemsichat = response.body
          this.progress = false
          this.load1 = true

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          }
        })
      } else {
        this.text1 = 'Başlangıç tarihi bitiş tarihinden büyük olamaz...'
        this.snackbar = true
      }
    }
  }


  function beforeMount() {


  }
</script>
<style>
</style>